import React from 'react'
import styled, { css } from 'styled-components'

const width = '201.7'
const height = '74.1'
const viewBox = '0 0 201.7 74.1'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <path
      key="key-0"
      d="M12.8 42.6H1.1v-6H31v6H19.3v30.9h-6.5V42.6zm20.2-6h16.4c4.6 0 8.3 1.4 10.7 3.7 1.9 2 3.1 4.7 3.1 8v.1c0 6.1-3.6 9.7-8.8 11.2l10 14h-7.6l-9.1-12.9h-8.1v12.9H33v-37zm16 18.3c4.6 0 7.6-2.4 7.6-6.2v-.1c0-4-2.8-6.1-7.6-6.1h-9.4v12.4H49zm19.5 3V36.6H75v21c0 6.9 3.5 10.5 9.3 10.5 5.7 0 9.3-3.5 9.3-10.3V36.6h6.5v20.9c0 11-6.2 16.6-15.9 16.6-9.6 0-15.7-5.5-15.7-16.2zm35.9 10.3l3.9-4.6c3.5 3.1 7.1 4.8 11.7 4.8 4 0 6.5-1.8 6.5-4.6v-.1c0-2.6-1.5-4.1-8.3-5.6-7.9-1.9-12.3-4.2-12.3-11V47c0-6.3 5.3-10.7 12.6-10.7 5.4 0 9.6 1.6 13.4 4.6l-3.5 4.9c-3.3-2.5-6.6-3.8-10-3.8-3.8 0-6 2-6 4.4v.1c0 2.9 1.7 4.1 8.8 5.8C129 54 133 56.8 133 62.9v.1c0 6.9-5.4 11-13.2 11-5.6.1-10.9-1.9-15.4-5.8zm43-25.6h-11.7v-6h29.9v6h-11.7v30.9h-6.5V42.6z"
      fill="#9aa3b3"
    />,
    <path
      key="key-1"
      d="M163.6 53.9h1.9v19.9h-1.9V53.9zm7.5 17.3l1.1-1.5c2.2 1.7 4.6 2.6 7.1 2.6 2.7 0 4.8-1.5 4.8-3.8v-.1c0-2.3-2.5-3.2-5.3-4-3.2-.9-6.8-1.9-6.8-5.5v.1c0-3.2 2.7-5.5 6.5-5.5 2.4 0 5.1.9 7 2.2l-1 1.6c-1.8-1.2-4-2-6.1-2-2.7 0-4.5 1.5-4.5 3.5v.1c0 2.2 2.7 3 5.5 3.9 3.2.9 6.5 2.1 6.5 5.6v.1c0 3.5-3 5.8-6.9 5.8-2.6-.2-5.8-1.4-7.9-3.1zm21.7-2.6v-13H190v-1.8h2.9v-6.3h1.9v6.3h7v1.8h-7v12.8c0 2.8 1.7 3.9 4 3.9 1 0 1.8-.2 2.9-.7v1.8c-1 .5-2 .7-3.2.7-3.2 0-5.7-1.7-5.7-5.5zm-27-21.1v2.6h-2.4v-2.6"
      fill="#9aa3b3"
    />,
    <path
      key="key-2"
      d="M132 6.5l-3.6 2.6c12.2 1.2 19.8 2.8 19.8 4.6 0 3.5-28.7 6.4-64.2 6.4-35.4 0-64.2-2.9-64.2-6.4 0-1.8 7.6-3.4 19.8-4.6L36 6.5c-20.8 2-34.3 5.3-34.3 9.1 0 6.2 36.8 11.2 82.3 11.2 45.4 0 82.3-5 82.3-11.2 0-3.8-13.5-7.1-34.3-9.1z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#9aa3b3"
    />,
    <path
      key="key-3"
      d="M91.2 5.2c-.1-.2-.3-.4-.5-.4H86L84.5.3c-.1-.5-.9-.5-1 0L82 4.8h-4.7c-.2 0-.4.2-.5.4-.1.2 0 .5.2.6l3.8 2.8-1.5 4.5c-.1.2 0 .5.2.6.2.1.5.1.6 0l3.8-2.8 3.8 2.8c.1.1.2.1.3.1.1 0 .2 0 .3-.1.2-.1.3-.4.2-.6L87 8.6l4-2.8c.2-.1.3-.4.2-.6zm35.4 0c-.1-.2-.3-.4-.5-.4h-4.7L119.9.3c-.1-.5-.9-.5-1 0l-1.5 4.5h-4.7c-.2 0-.4.2-.5.4-.1.2 0 .5.2.6l3.8 2.8-1.5 4.5c-.1.2 0 .5.2.6.2.1.5.1.6 0l3.8-2.8 3.8 2.8c.1.1.2.1.3.1s.2 0 .3-.1c.2-.1.3-.4.2-.6l-1.5-4.5 3.8-2.8c.4-.1.5-.4.4-.6zm-17.7 0c-.1-.2-.3-.4-.5-.4h-4.7L102.2.3c-.1-.5-.9-.5-1 0l-1.5 4.5H95c-.2 0-.4.2-.5.4-.1.2 0 .5.2.6l3.8 2.8-1.5 4.5c-.1.2 0 .5.2.6.2.1.5.1.6 0l3.8-2.8 3.8 2.8c.1.1.2.1.3.1.1 0 .2 0 .3-.1.2-.1.3-.4.2-.6l-1.5-4.5 3.8-2.8c.4-.1.5-.4.4-.6zm-53.1 0c-.1-.2-.3-.4-.5-.4h-4.7L49.1.3c-.1-.5-.9-.5-1 0l-1.5 4.5h-4.7c-.2 0-.4.2-.5.4-.1.2 0 .5.2.6l3.8 2.8-1.5 4.5c-.1.2 0 .5.2.6.2.1.5.1.6 0l3.8-2.8 3.8 2.8c.1.1.2.1.3.1.1 0 .2 0 .3-.1.2-.1.3-.4.2-.6l-1.5-4.5 3.8-2.8c.4-.1.5-.4.4-.6zm17.7 0c-.1-.2-.3-.4-.5-.4h-4.7L66.8.3c-.1-.5-.9-.5-1 0l-1.5 4.5h-4.7c-.2 0-.4.2-.5.4-.1.2 0 .5.2.6l3.8 2.8-1.5 4.5c-.1.2 0 .5.2.6.2.1.5.1.6 0l3.8-2.8 3.8 2.8c.1.1.2.1.3.1.1 0 .2 0 .3-.1.2-.1.3-.4.2-.6l-1.5-4.5 3.8-2.8c.4-.1.5-.4.4-.6z"
      fill="#9aa3b3"
    />
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'IconTrustist'
})
